// extracted by mini-css-extract-plugin
export default {"scoreDisplay":"ScoreDisplay_scoreDisplay__Vdk+2"};